const runLatencyTest = (cb) => {
    const debug = false

    if(!debug && navigator && navigator.connection && navigator.connection.downlink) {
        cb(navigator.connection.downlink > pmkinoFrontVars.cinemaData.front.latency_test.navigator_connection_downlink)
        return
    }

    const arrTimes = []
    const timesToTest = 5
    const tThreshold = pmkinoFrontVars.cinemaData.front.latency_test.time_threshold //ms
    const testImage = window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/pmkino/assets-static/px.gif'
    const dummyImage = new Image()
    let i = 0

    testLatency(function(avg) {
        cb(avg <= tThreshold)
    })

    function testLatency(done) {
        const tStart = new Date().getTime()

        if(i < timesToTest - 1) {
            dummyImage.src = testImage + '?t=' + tStart;
            dummyImage.onload = function() {
                const tEnd = new Date().getTime()
                const tTimeTook = tEnd - tStart
                arrTimes[i] = tTimeTook
                testLatency(done)
                i++
            }
        } else {
            const sum = arrTimes.reduce(function(a, b) { return a + b });
            const avg = sum / arrTimes.length
            done(avg)
        }
    }
}

export default runLatencyTest
